export { default as TabsScreen } from './TabsScreen';
//# sourceMappingURL=index.js.map